import axios from '../axiosInstance';

export async function getSites({ search = '', pageSize = 50, lastId = null, signal = null } = {}) {
    const { data } = await axios.get('/Sites/getSites', { params: { search, pageSize, lastId }, signal });
    // data: { items, lastId, hasMore }
    return data;
}
